import { Module } from './module.model';
import { PixelDimensions2D } from './pixel-dimensions-2d.model';

export class Section extends Module {
  private readonly centimeterToPixelRatio = 2.6;

  public get title(): string {
    return this.name;
  }

  public get pixelDimensions2D() {
    return new PixelDimensions2D(this.dimensions.widthCm, this.dimensions.heightCm, this.centimeterToPixelRatio);
  }
}
